// InfoModal.jsx
import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import "./clinicWeekly.css";

export default function InfoModal({ open, title, message, onClose }) {
  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = prev; };
  }, [open]);

  if (!open) return null;

  const content = (
    <div className="modal-backdrop modal-zfix" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{title || "Thông báo"}</h3>
          <button className="icon-btn" onClick={onClose}>×</button>
        </div>
        <div style={{whiteSpace:"pre-line"}}>{message}</div>
        <div className="modal-actions">
          <button className="btn ghost" onClick={onClose}>Đóng</button>
        </div>
      </div>
    </div>
  );

  return createPortal(content, document.body);
}
